import { render, staticRenderFns } from "./OrderDraftRequestedDelivery.vue?vue&type=template&id=08f63c16&"
import script from "./OrderDraftRequestedDelivery.vue?vue&type=script&lang=js&"
export * from "./OrderDraftRequestedDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports